import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import Header from "./BrokerHeader";
import SideBar from "./BrokerSidebar";
import 'iconify-icon';
export default function BrokerDashboard() {
    const [lists, setLists] = useState([]);
    const [lenders, setLenders] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [counts, setCounts] = useState({});
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const GetBrokerCount = () => {
        axios
            .get(config.APIACTIVATEURL + config.USERDASHBOARD + "?Id=" + localStorage.getItem("userId"), { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setCounts(response.data)
                }
            });
    };
    const GetLastPageData = () => {
        GetData(totalPages)
    }
    const GetFirstPageData = () => {
        GetData("1")
    }
    const GetPageData = (number) => {
        setPageNumber(number);
        if (pageNumber !== number)
            GetData(number)
    }
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map((number) => {
        return (
            <li className="page-item" key={number} id={number} onClick={() => GetPageData(number)}>
                <Link className="page-link">{number}</Link>
            </li>
        );
    });
    const GetData = (number) => {
        axios
            .get(config.APIACTIVATEURL + config.GETUSERLENDINGAPPLICATION + "?id=" + localStorage.getItem("userId") + "&pageNumber=" + number + "&pageSize=" + pageSize, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLists(response.data.data.data);
                    setPageNumber(response.data.data.pageNumber);
                    setPageSize(response.data.data.pageSize);
                    setTotalPages(response.data.data.totalPages);
                    setData(response.data.data);
                    setTotalRecords(response.data.data.totalRecords);
                }
            });
    };
    const GetLenderCommission = (number) => {
        axios
            .get(config.APIACTIVATEURL + config.GETLENDERSCOMMISSIONS + "?pageNumber=" + number + "&pageSize=" + pageSize + "", { ...headerconfig })
            .then((response) => {
                if (response.status === 200) {
                    setLenders(response.data.data.data);
                    setPageNumber(response.data.data.pageNumber);
                    setPageSize(response.data.data.pageSize);
                    setTotalPages(response.data.data.totalPages);
                    setData(response.data.data);
                    setTotalRecords(response.data.data.totalRecords);
                }
            });
    };
    useEffect(() => {
        GetData(pageNumber);
        //GetLenderCommission(pageNumber);
        GetBrokerCount();
    }, [])
    return (
        <div className="layout-wrapper" style={{ backgroundColor: "#F4F7FB" }}>
            <Header></Header>
            <SideBar></SideBar>
            <div className="container-fluid" style={{ marginTop: "120px" }}>
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-6">
                                <div className="card text-bg-primary">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-7">
                                                <div className="d-flex flex-column h-100">
                                                    <div className="hstack gap-3">
                                                        <span className="d-flex align-items-center justify-content-center round-48 bg-white rounded flex-shrink-0">
                                                            <iconify-icon icon="solar:course-up-outline" className="fs-7 text-muted" />
                                                        </span>
                                                        <h5 className="text-white fs-6 mb-0 text-nowrap">Welcome Back
                                                        <br />{localStorage.getItem("userName")}
                                                        </h5>
                                                    </div>
                                                    <div className="mt-4 mt-sm-auto">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <span className="opacity-75">MTD Commission</span>
                                                                <h4 className="mb-0 text-white mt-1 text-nowrap fs-13 fw-bolder">
                                                                    $ {counts.monthlyCommission}</h4>
                                                            </div>
                                                            <div className="col-6 border-start border-light">
                                                                <span className="opacity-75">YTD Commission</span>
                                                                <h4 className="mb-0 text-white mt-1 text-nowrap fs-13 fw-bolder">
                                                                    $ {counts.yearlyCommission}</h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-5 text-center text-md-end">
                                                <img src="/assets/images/backgrounds/welcome-bg.png" alt="welcome" className="img-fluid mb-n7 mt-2" width={180} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="row">
                                    <div className="col-6">
                                        <div className="card bg-secondary-subtle overflow-hidden shadow-none">
                                            <div className="card-body p-4">
                                                <div className="d-flex align-items-start">
                                                    <span className="me-3">
                                                        <span className="d-flex align-items-center justify-content-center round-48 bg-white rounded flex-shrink-0">
                                                            <iconify-icon icon="solar:user-plus-broken" className="fs-7 text-muted" />
                                                        </span>
                                                    </span>
                                                    <div>
                                                        <span className="text-dark-light">Total Leads</span>
                                                        <div className="hstack gap-6">
                                                            <h5 className="mb-0 fs-7">{counts.leads}</h5>
                                                            <Link to="/userdashboard/applications"><i className="fa fa-eye text-muted me-2"></i>View</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="customers" />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="card bg-primary-subtle overflow-hidden shadow-none">
                                            <div className="card-body p-4">
                                                <div className="d-flex align-items-start">
                                                    <span className="me-3">
                                                        <span className="d-flex align-items-center justify-content-center round-48 bg-white rounded flex-shrink-0">
                                                            <iconify-icon icon="material-symbols:sms" className="fs-7 text-muted" />
                                                        </span>
                                                    </span>
                                                    <div>
                                                        <span className="text-dark-light">SMS Available</span>
                                                        <div className="hstack gap-6">
                                                            <h5 className="mb-0 fs-7">{counts.smsAvailable}</h5>
                                                            <Link to="/userdashboard/usercredits"><i className="fa fa-eye text-muted me-2"></i>View</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="card bg-danger-subtle overflow-hidden shadow-none">
                                            <div className="card-body p-4">
                                                <div className="d-flex align-items-start">
                                                    <span className="me-3">
                                                        <span className="d-flex align-items-center justify-content-center round-48 bg-white rounded flex-shrink-0">
                                                            <iconify-icon icon="material-symbols:phone-in-talk-rounded" className="fs-7 text-muted" />
                                                        </span>
                                                    </span>
                                                    <div>
                                                        <span className="text-dark-light">Call(Mins) Available</span>
                                                        <div className="hstack gap-6">
                                                            <h5 className="mb-0 fs-7">{counts.callAvailable}</h5>
                                                            <Link to="/userdashboard/usercredits"><i className="fa fa-eye text-muted me-2"></i>View</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="card bg-secondary-subtle overflow-hidden shadow-none">
                                            <div className="card-body p-4">
                                                <div className="d-flex align-items-start">
                                                    <span className="me-3">
                                                        <span className="d-flex align-items-center justify-content-center round-48 bg-white rounded flex-shrink-0">
                                                            <iconify-icon icon="material-symbols:mail" className="fs-7 text-muted" />
                                                        </span>
                                                    </span>
                                                    <div>
                                                        <span className="text-dark-light">Emails</span>
                                                        <div className="hstack gap-6">
                                                            <h5 className="mb-0 fs-7">{counts.emailAvailable}</h5>
                                                            <Link to="/userdashboard/usercredits"><i className="fa fa-eye text-muted me-2"></i>View</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row flex-nowrap">
                            <div className="col">
                                <div className="card primary-gradient">
                                    <div className="card-body text-center px-9 pb-4">
                                        <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-primary flex-shrink-0 mb-3 mx-auto">
                                            <iconify-icon icon="material-symbols:thumb-up" className="fs-7 text-white" />
                                        </div>
                                        <h6 className="fw-normal fs-3 mb-1">Submitted</h6>
                                        <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                            {counts.submitted}</h4>
                                        <Link to="/userdashboard/applications/submitted" className="btn btn-primary fs-2 fw-semibold text-nowrap">View
                                            Details</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card warning-gradient">
                                    <div className="card-body text-center px-9 pb-4">
                                        <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-warning flex-shrink-0 mb-3 mx-auto">
                                            <iconify-icon icon="solar:recive-twice-square-linear" className="fs-7 text-white" />
                                        </div>
                                        <h6 className="fw-normal fs-3 mb-1">Pending</h6>
                                        <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                            {counts.pending}</h4>
                                        <Link to={"/userdashboard/applications/pending"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View
                                            Details</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card secondary-gradient">
                                    <div className="card-body text-center px-9 pb-4">
                                        <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-success flex-shrink-0 mb-3 mx-auto">
                                            <iconify-icon icon="material-symbols:thumb-up" className="fs-7 text-white" />
                                        </div>
                                        <h6 className="fw-normal fs-3 mb-1">Approved</h6>
                                        <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                            {counts.approved}</h4>
                                        <Link to={"/userdashboard/applications/approved"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View
                                            Details</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card danger-gradient">
                                    <div className="card-body text-center px-9 pb-4">
                                        <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-danger flex-shrink-0 mb-3 mx-auto">
                                            <iconify-icon icon="ic:baseline-sync-problem" className="fs-7 text-white" />
                                        </div>
                                        <h6 className="fw-normal fs-3 mb-1">Awaiting Funding</h6>
                                        <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                            {counts.waitingFunding}</h4>
                                            <Link to={"/userdashboard/applications/waitingfunding"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View
                                            Details</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card success-gradient">
                                    <div className="card-body text-center px-9 pb-4">
                                        <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-danger flex-shrink-0 mb-3 mx-auto">
                                            <iconify-icon icon="material-symbols:thumb-down-sharp" className="fs-7 text-white" />
                                        </div>
                                        <h6 className="fw-normal fs-3 mb-1">Declined</h6>
                                        <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                            {counts.declined}</h4>
                                        <Link to={"/userdashboard/applications/declined"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View
                                            Details</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card success-gradient">
                                    <div className="card-body text-center px-9 pb-4">
                                        <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-success flex-shrink-0 mb-3 mx-auto">
                                            <iconify-icon icon="material-symbols:attach-money" className="fs-7 text-white" />
                                        </div>
                                        <h6 className="fw-normal fs-3 mb-1">Credits Available</h6>
                                        <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                            {counts.availableCredits}</h4>
                                            <Link to={"/userdashboard/usercredits"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View
                                            Details</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card w-100 position-relative overflow-hidden">
                            <div className="px-4 py-3 border-bottom">
                                <h4 className="card-title mb-0">Recent Applications</h4>
                            </div>
                            <div className="card-body p-4">
                                <div className="table-responsive mb-4 border rounded-1">
                                    <table className="table text-nowrap mb-0 align-middle">
                                        <thead className="text-dark fs-4">
                                            <tr>
                                                <th>
                                                    <h6 className="fs-4 fw-semibold mb-0">Business Name</h6>
                                                </th>
                                                <th>
                                                    <h6 className="fs-4 fw-semibold mb-0">Owner</h6>
                                                </th>
                                                <th>
                                                    <h6 className="fs-4 fw-semibold mb-0">Co-Owner</h6>
                                                </th>
                                                <th>
                                                    <h6 className="fs-4 fw-semibold mb-0">Status</h6>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {lists.length>0 && lists.map(l=>
                                            <tr>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                    <Link to={"/lendingapplication/"+l.lendingApplicationId} target="_blank" className="text-bg-secondary text-white fs-6 round-40 rounded-circle me-n2 card-hover border border-2 border-white d-flex align-items-center justify-content-center">
                                                            {l.businessLegalName?.charAt(0).toUpperCase() || '?'}
                                                        </Link>
                                                        <div className="ms-3">
                                                            <h6 className="fs-4 fw-semibold mb-0">{l.businessLegalName}</h6>
                                                            <span className="fw-normal">{l.businessEmail}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div className="ms-3">
                                                            <h6 className="fs-4 fw-semibold mb-0">{l.ownerName}</h6>
                                                            <span className="fw-normal">{l.oHomePhone}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div className="ms-3">
                                                            <h6 className="fs-4 fw-semibold mb-0">{l.coOwnerName}</h6>
                                                            <span className="fw-normal">{l.cHomePhone}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="badge bg-success-subtle text-success">{l.status}</span>
                                                </td>
                                                {/* <td>
                                                    {l.documents===null?
                                                    <span className="badge bg-success-subtle text-warning">PENDING</span>
                                                    :
                                                    <span className="badge bg-success-subtle text-success">UPLOADED</span>
}
                                                </td> */}
                                            </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                                                <div className="flex-shrink-0">
                                                                    <div className="text-muted">
                                                                        Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                                                    </div>
                                                                </div>
                                                                <ul className="pagination pagination-separated pagination-sm mb-0">
                                                                    <li className={"page-item" + (data.previousPage === null ? 'disabled' : '')} onClick={() => GetFirstPageData()}>
                                                                        <Link className="page-link">Previous</Link>
                                                                    </li>
                                                                    {renderPageNumbers}
                                                                    <li className={"page-item" + (data.nextPage === null ? 'disabled' : '')} onClick={() => GetLastPageData()}>
                                                                        <Link className="page-link">Next</Link>
                                                                    </li>
                                                                </ul>
                                                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}